<template>
  <div class="home-info">
    <van-button color="#FC6E09" plain block @click="checkBut">全部已读</van-button>
    <!-- <div class="home-top-button">全部已读</div> -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div
          class="home-info-box"
          v-for="(item,index) in infoData"
          :key="index"
          @click="dataInfo(item)"
        >
          <div class="info-box-padding">
            <div class="info-box-box">
              <div class="info-box-left">
                <span class="info-icon" v-if="item.readFlag==0"></span>
                <!-- <span class="info-icon"></span> -->
                <span class="info-font system">{{ item.accessType=='1' ? '消息系统' : '访问足迹' }}</span>
              </div>
              <span class="info-font info-time">{{item.showTime}}</span>
            </div>
            <div class="info-content">
              <div class="info-img">
                <img :src="item.avatarName || headerImg" alt />
              </div>
              <div class="info-con-left">
                <div class="info-name">
                  <div class="info-font font-title">{{ item.nickName}}</div>
                  <div class="info-phone">{{item.userPhone}}</div>
                </div>
                <div class="info-font font-content">{{item.accessName}}</div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Icon, Dialog, Toast } from 'vant'
import URL from "@/api/api";
export default {
  data() {
    return {
      infoData: [],
      page: 0,//当前页数
      size: 10,//每页条数
      total: '',
      loading: false,//加载中
      finished: false,//是否已加载完成
      refreshing: false,//下拉刷新
      headerImg: require('./img/userImg.png')
    }
  },
  mounted() {
    // this.getList()
  },
  methods: {
    onRefresh() {
      let that = this
      // console.log(this.refreshing);
      that.finished = false;
      that.page = 0
      that.loading = true;
      that.getList();
    },
    onLoad() {
      this.getList();
    },
    getList() {
      let that = this
      let data = {
        agentPhoneNo: localStorage.getItem('phone'),
        page: that.page,
        size: that.size
      }
      that.$fetchPost(URL.getMessageList.url, data).then((res) => {
        if (res.data.code == 20000) {
          that.refreshing = false;
          that.loading = false;
          that.total = res.data.data.totalCount;
          let list = res.data.data.vos;
          if (list == null || list.length === 0) {
            // 加载结束
            that.finished = true;
            that.newDataList = []
            return;
          }
          // 将新数据与老数据进行合并
          if (that.page > 1) {
            that.infoData = [...that.infoData, ...list]
          } else {
            that.infoData = list
          }
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.infoData.length >= that.total) {
            that.finished = true;
          }
          //说明可能还有下一页
          if (that.infoData.length < that.total) {
            that.page++;
          }
        }
      })
    },
    //全部已读
    checkBut() {
      let agentPhoneNo=localStorage.getItem('phone')
      let type='all'
      let id=''
      let message='是否选择全部已读！'
      this.modifyStatus(agentPhoneNo,type,id,message)
    },
    //修改状态
    modifyStatus(agentPhoneNo,type,id,message){
      Dialog.alert({
        message: message,
      }).then(() => {
        let data = {
          agentPhoneNo: agentPhoneNo,
          type:type,
          id: id
        }
        this.$fetchPost(URL.MsgUpdatestate.url, this.$toFormData(data)).then((res) => {
          if (res.data.code == 20000) {
            this.getList()
          } else {
            Toast(res.data.msg)
          }
        })
      });
    },
    // 修改单个消息状态
    dataInfo(v) {
      let agentPhoneNo=''
      let type='single'
      let id=v.id
      let message=v.nickName+v.accessName
      this.modifyStatus(agentPhoneNo,type,id,message)
    }
  }
}
</script>

<style lang="less" scoped>
.home-info {
  width: 375px;
  height: 100vh;
  background: #fffbf8;
  overflow: hidden;
  font-family: PingFang SC;
  font-weight: Regular;
  .van-pull-refresh {
    height: calc(100vh - 50px);
    overflow: scroll;
  }
  .van-button {
    width: auto;
    padding: 3px;
    height: auto;
    margin: 5px 0 0 10px;
  }
  .home-info-box:first-child {
    margin-top: 20px;
  }
  .home-info-box {
    width: 355px;
    height: 110px;
    margin: 10px auto 0;
    background: url("./img/info_bg.png") no-repeat 100% 100%;
    // border-radius: 10px;
    .info-box-padding {
      padding: 10px 20px;
    }
    .info-content {
      display: flex;
      margin-top: 16.5px;
      .info-img {
        width: 43px;
        height: 43px;
        img {
          width: 100%;
          border-radius: 50%;
        }
      }
      .info-con-left {
        margin-left: 9.5px;
        .info-name {
          width: 272.5px;
          display: flex;
          justify-content: space-between;
          .info-phone {
            font-size: 10.5px;
            color: #333333;
          }
        }
      }
    }
    .info-font {
      font-size: 12px;
      font-weight: Medium;
      color: #712600;
    }
    .font-title {
      // margin-top: 8px;
      font-weight: bold;
      color: #3e1500;
    }
    .font-content {
      margin-top: 5px;
    }
    .info-box-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .info-box-left {
        display: flex;
        align-items: center;
      }
      span {
        display: block;
        font-family: PingFang SC;
      }
      .info-icon {
        width: 6px;
        height: 6px;
        background: #cf4c62;
        border-radius: 50%;
      }
      .system {
        margin-left: 5.5px;
      }
      .info-time {
        font-weight: lighter;
      }
    }
  }
}
</style>